import {
  Box,
  Divider,
  Stack,
  Typography,
  IconButton,
  Popper,
  Paper,
  ClickAwayListener,
  FilledInput,
  Button,
} from "@mui/material";
import { FC, useState, useRef } from "react";
import { FiPhone, FiSearch, FiChevronDown } from "react-icons/fi";
import { HeaderNavInterface } from "src/lib/utils/interfaces";

interface HaiAnhDesktopHeaderNavProps {
  nav: Array<HeaderNavInterface>;
  hotline: string | undefined;
  isActive: (item: HeaderNavInterface, sectionId: string | undefined) => boolean;
  onClick: (item: HeaderNavInterface, sectionId: string | undefined) => void;
  showSearch?: boolean;
  searchPlaceholder?: string;
}

export const HaiAnhDesktopHeaderNav: FC<HaiAnhDesktopHeaderNavProps> = ({
  nav,
  hotline,
  isActive,
  onClick,
  showSearch = false,
  searchPlaceholder = "Tìm kiếm sản phẩm...",
}) => {
  const [searchOpen, setSearchOpen] = useState(false);
  const searchAnchorRef = useRef<HTMLButtonElement>(null);

  const handleSearchToggle = () => {
    setSearchOpen((prev) => !prev);
  };

  const handleSearchClose = () => {
    setSearchOpen(false);
  };

  const handleSearchSubmit = (searchValue: string) => {
    console.log("Search:", searchValue);
    setSearchOpen(false);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      width="100%"
      px={3}
      py={2}
    >
      <Box display="flex" gap={5} height="100%">
        {nav.map((item, index) => {
          const sectionId = item.target?.replace("#", "");
          const isItemActive = isActive(item, sectionId);
          const hasDropdown = item.label?.includes("SẢN PHẨM") || item.label?.includes("GIẢI PHÁP");

          return (
            <Box
              key={index}
              component={item.action === "link" ? "a" : "div"}
              href={item.action === "link" ? item.target : undefined}
              onClick={
                item.action === "scroll"
                  ? (e: React.MouseEvent) => {
                      e.preventDefault();
                      onClick(item, sectionId);
                    }
                  : undefined
              }
              display="flex"
              alignItems="center"
              gap={0.5}
              sx={{
                height: "100%",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "14px",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                color: isItemActive ? "primary.main" : "#333",
                borderBottom: "2px solid",
                borderColor: isItemActive ? "primary.main" : "transparent",
                padding: "10px 0",
                transition: "color 0.3s ease",
                "&:hover": {
                  cursor: "pointer",
                  color: "primary.main",
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "14px",
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                }}
              >
                {item.label}
              </Typography>
              {hasDropdown && <FiChevronDown size={12} style={{ marginLeft: "4px" }} />}
            </Box>
          );
        })}
      </Box>

      <Stack direction="row" alignItems="center" spacing={2}>
        {showSearch && (
          <IconButton
            ref={searchAnchorRef}
            onClick={handleSearchToggle}
            size="small"
            sx={{
              color: "#666",
              padding: "8px",
              borderRadius: "4px",
              transition: "background-color 0.3s ease",
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <FiSearch size={18} />
          </IconButton>
        )}

        {hotline && (
          <Box
            display="flex"
            alignItems="center"
            gap={1.5}
            sx={{
              cursor: "pointer",
              fontWeight: 500,
            }}
            onClick={() => {
              window.location.href = `tel:${hotline}`;
            }}
          >
            <Box
              sx={{
                backgroundColor: "primary.main",
                width: 40,
                height: 40,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FiPhone size={16} color="#333" />
            </Box>
            <Stack sx={{ lineHeight: 1.2 }}>
              <Typography
                variant="caption"
                fontWeight={500}
                sx={{
                  color: "#666",
                  fontSize: "12px",
                }}
              >
                Hotline
              </Typography>
              <Typography
                sx={{
                  color: "#333",
                  fontSize: "14px",
                  fontWeight: 700,
                }}
              >
                {hotline}
              </Typography>
            </Stack>
          </Box>
        )}
      </Stack>
    </Stack>
  );
};

HaiAnhDesktopHeaderNav.displayName = "HaiAnhDesktopHeaderNav";
